import useWindowSize from 'components/util/useWindowSize'
import LeftRobotCard from '../cards/new/common/LeftRobotCard'
import Button from 'components/forms/Button'
import { FC } from 'react'

type Props = {
  onBuyNow: () => void
}

const VOPhoneService: FC<Props> = ({ onBuyNow }) => {
  const size = useWindowSize()
  return (
    <LeftRobotCard
      image={{
        alt: 'Robot pointing to phone with WhatsApp message',
        desktop: {
          dimensions: {
            height: 490,
            width: 599,
          },
          src: '/images/new/whatsapp/vo-phone-and-wa.png',
        },
        mobile: {
          dimensions: {
            height: 490,
            width: 599,
          },
          src: '/images/new/whatsapp/vo-phone-and-wa.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '40%' : '100%'}
      reverseColumnOrder={!size.isLgOrHigher}
      overrideAllImageStyles
      imageStyle={{
        maxHeight: '100%',
        objectFit: 'contain',
        width: '100%',
      }}
      imageContainerContentBottom={
        <div className='px-4 pt-6 pb-4 d-lg-none'>
          <Button className='w-100'>Buy Now</Button>
        </div>
      }
    >
      <div className='d-flex flex-1 flex-column gap-2 gap-lg-4 px-4 py-lg-10 pt-8'>
        <h2 className='fw-semibold fs-fluid-36-48 lh-105 mb-lg-4 mb-7'>
          Unlock a world-class business solution with our WhatsApp Business Number
          number service.
        </h2>
        <span className='fw-semibold lh-132 lh-lg-119 fs-fluid-18-28 pb-3 pb-lg-5'>
          In order to unlock the functionality of{' '}
          <strong>WhatsApp for Business</strong>, you will need a dedicated{' '}
          <strong>WhatsApp Business Number number</strong>.
        </span>
        <span className='fw-semibold lh-114 lh-lg-13 fs-fluid-16-22 pb-4 pb-lg-0'>
          With our service, you can choose your bespoke business number today
          and immediately start using your new virtual phone number on all of
          your marketing materials. 
        </span>
        <Button
          onClick={onBuyNow}
          className='d-none d-lg-block align-self-lg-end mt-lg-10'
        >
          Buy Now
        </Button>
      </div>
    </LeftRobotCard>
  )
}

export default VOPhoneService
